import { Capacitor } from '@capacitor/core';
import { StatusBar, Style } from '@capacitor/status-bar';

/**
 * Configure the native status bar so the WebView renders BELOW it rather than
 * underneath it. Without this, on devices where `env(safe-area-inset-top)`
 * reports 0 (notably Android status bars), top-pinned UI — the scrolling
 * notification ticker, the connection-lost banner, the promo modals — draws
 * under the clock / signal icons.
 *
 * No-op on web (the plugin isn't implemented there); guarded by the native
 * platform check so a thrown "not implemented" never surfaces.
 */
export const initStatusBar = async (): Promise<void> => {
  if (!Capacitor.isNativePlatform()) return;
  try {
    // Reinforces `overlaysWebView: false` from capacitor.config.ts at runtime
    // (config alone can be overridden by the platform theme on some devices).
    await StatusBar.setOverlaysWebView({ overlay: false });
    // Light glyphs for the app's dark chrome.
    await StatusBar.setStyle({ style: Style.Dark });
    if (Capacitor.getPlatform() === 'android') {
      await StatusBar.setBackgroundColor({ color: '#12100c' });
    }
  } catch {
    // Plugin unavailable / platform without a status bar — safe to ignore.
  }
};
